import FavoriteIcon, { SMALL, MEDIUM } from './FavoriteIcon';

export default FavoriteIcon;
export { SMALL, MEDIUM };
